


import createValidatePropsMethod from './../lib/createValidatePropsMethod'

/**
 * Checks that the file is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} repository
 */
export const validateFile = createValidatePropsMethod({
  'id': `Missing prop on file 'id'.`,
  'path': `Missing prop on file 'path'.`,
  'text': `Missing prop on file 'text'.`,
})


/**
 * Add a file under a branch
 * @param {object} file
 * @param {string} branchId
 * @returns {object}
 */
export function addFile(file, branchId){
  validateFile(file)
  if (!branchId)
    throw new Error(`Missing parameter 'branchId'.`)
  return {
    type: 'ADD_FILE',
    payload: { file, branchId }
  }
}

/**
 * Move a file to a new branch
 * @param {object} file
 * @param {string} oldBranchId
 * @param {string} newBranchId
 * @returns {object}
 */
export function moveFile(file, oldBranchId, newBranchId){
  validateFile(file)
  if (!oldBranchId)
    throw new Error(`Missing parameter 'oldBranchId'.`)
  if (!newBranchId)
    throw new Error(`Missing parameter 'newBranchId'.`)
  return {
    type: 'MOVE_FILE',
    payload: { file, oldBranchId, newBranchId },
  }
}

/**
 * Updates a file's content and marks it as uncommited
 * @param {string} fileId
 * @param {string} content
 */
export function updateFileContent(fileId, text){
  if (!fileId)
    throw new Error(`Invalid fileId '${fileId}'.`)
  if (!text)
    throw new Error(`Invalid text '${text}'.`)
  return {
    type: 'UPDATE_FILE_CONTENT',
    payload: {
      fileId,
      text,
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/files/actions.js